import React, { createContext, useCallback, useState } from 'react';
import { modalNames } from '../../../../shared/configs/modal';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { useInvalidateRoomAttachments } from '../../../../api/roomAttachments';
import { useEditRoomAttachmentMutation } from '../../../../api/editRoomAttachment';

const modalName = modalNames.attachmentsForm;

export const SubmitContext = createContext();

export const SubmitProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  const { mutateAsync: editAttachment } = useEditRoomAttachmentMutation();

  const invalidateAttachments = useInvalidateRoomAttachments();

  const { getProps, closeAndKeepProps } = useModalMethods();

  const onSubmit = useCallback(
    async (values) => {
      const { addressId, attachment } = getProps(modalName) ?? {};

      setLoading(true);

      const result = await editAttachment({
        addressId,
        attachId: attachment.id,
        data: values,
        showErrorMessage: true,
      });

      setLoading(false);

      if (result !== 'Error') {
        invalidateAttachments({ addressId });
        closeAndKeepProps(modalName);
      }
    },
    [editAttachment, closeAndKeepProps, getProps, invalidateAttachments]
  );

  return (
    <SubmitContext.Provider value={{ onSubmit, loading }}>
      {children}
    </SubmitContext.Provider>
  );
};
